// Pure formatter for the "last recorded" line in the BHI assessment modal.
// CommonJS so Jest can require it directly (no ESM transform in this repo);
// esbuild bundles it for the modal via the same CJS interop the modal already
// uses for bhi-assessment-entry.js.

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// 'YYYY-MM-DD' -> 'Mon D, YYYY'. TZ-safe: parses the string parts directly
// rather than `new Date('YYYY-MM-DD')` (which is UTC-midnight and can shift a
// day in negative timezones). Returns '' on malformed/missing input.
function prettyDate(ymd) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(ymd || ''));
  if (!m) return '';
  const mon = MONTHS[Number(m[2]) - 1];
  if (!mon) return '';
  return `${mon} ${Number(m[3])}, ${m[1]}`;
}

// Format an assessment record as a one-line attribution string, or null when
// there is no assessment to show. Segments are joined with ' · ' and only
// present segments are included (no doubled separators).
function formatLastRecorded(a) {
  if (!a) return null;
  const scale = a.scale || 'assessment';
  const hasScore = a.score != null && a.score !== '';
  const scorePart = hasScore ? `${a.score}${a.severity ? ` (${a.severity})` : ''}` : '';
  const head = scorePart ? `Last ${scale}: ${scorePart}` : `Last ${scale}`;

  const segments = [head];
  if (a.recordedBy) {
    segments.push(`by ${a.recordedBy}${a.source === 'kiosk' ? ' (kiosk)' : ''}`);
  } else if (a.source === 'kiosk') {
    segments.push('via kiosk');
  }
  const d = prettyDate(a.date);
  if (d) segments.push(d);

  return segments.join(' · ');
}

module.exports = { formatLastRecorded, prettyDate };
